import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import FormButton from '../../../Components/Buttons/FormButton';
import { frequency, ends, days } from '../../../Data/dropdownDataList';
import FormSelect from '../../../Components/FormTag/FormSelect';
import FormRadioButton from '../../../Components/FormTag/FormRadioButton';
import { ScheduleCountData } from './ScheduleCount.type';
import InputFiled from '../../../Components/FormTag/InputFiled';
import { useNavigate } from "react-router-dom";

type ScheduleCountByLocationProps = {
    handleClose: () => void;
};

const ScheduleCountByLocationModal: React.FC<ScheduleCountByLocationProps> = ({ handleClose }) => {
    const [selectedDays, setSelectedDays] = useState<number[]>([]);
    const [selectedFrequency, setSelectedFrequency] = useState<string>('1');

    useEffect(() => {
        setSelectedDays([]);
    }, [selectedFrequency]);

    const navigate = useNavigate();

    const handleFrequencyChange = (selected: any) => {
        const selectedValue = selected?.value || '';
        setSelectedFrequency(selectedValue);
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        handleClose();
    };

    const { control, formState: { errors } } = useForm<typeof frequency>({
        defaultValues: frequency,
    });

    const [selectedEnds, setSelectedEnds] = useState<string>("1");
    const handleEndsChange = (value: boolean) => {
        setSelectedEnds(value ? "1" : "0");
        setScheduleCounAttributetData((prev) => ({ ...prev, ends: value }));
    };

    const [ScheduleCounAttributetData, setScheduleCounAttributetData] = useState<ScheduleCountData>(new ScheduleCountData());
    const { register } = useForm<ScheduleCountData>({
        defaultValues: ScheduleCounAttributetData,
    });

    return (
        <div className=''>
            <form onSubmit={handleSubmit} className="form">
                <div className="d-flex justify-content-right mt-4">
                    <div className="px-2 col-4">
                        <label className="fw-medium">Frequency</label>
                        <div className="mt-2">
                            <FormSelect
                                name="frequency"
                                tabIndex={1}
                                control={control}
                                optionList={frequency}
                                required={true}
                                className="form-control p-0"
                                placeholder="Daily"
                                isSearchable={true}
                                onChange={handleFrequencyChange}
                            />
                        </div>
                    </div>
                    {selectedFrequency === "3" && (
                        <div className="px-2 col-4">
                            <label className="fw-medium">Date</label>
                            <div className="mt-2">
                                <InputFiled
                                    tabIndex={4}
                                    type="date"
                                    register={register}
                                    name="monthly_date"
                                    errors={errors}
                                    className="form-control"
                                    placeholder="MM/DD/YYYY"
                                />
                            </div>
                        </div>
                    )}
                </div>
                {selectedFrequency === "2" && (
                    <div className="d-flex justify-content-right mt-4 col-10">
                        <div className="px-2 col-10">
                            <label className="fw-medium">Repeat On</label>
                            <div className="mt-2 days-selector">
                                {days.map((day, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setSelectedDays([index])}
                                        type="button"
                                        className={`btn btn-circle fw-medium repeat-day-btn ${selectedDays.includes(index)
                                            ? 'days-btn-active'
                                            : 'text-grey'
                                            }`}
                                        
                                    >
                                        {day}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                <div className="d-flex justify-content-right mt-4">
                    <div className="px-2 col-6">
                        <label className="fw-medium">Ends</label>
                        <div className="mt-2 row">
                            {ends.map((endOption, index) => (
                                <FormRadioButton
                                    key={index}
                                    className="col-3"
                                    radioId={`endsRadio${index}`}
                                    tabIndex={5 + index}
                                    required={false}
                                    name="ends"
                                    register={register}
                                    errors={errors}
                                    labelName={endOption.labelName}
                                    defaultChecked={ScheduleCounAttributetData.ends === endOption.value}
                                    onClick={() => handleEndsChange(endOption.value)}
                                    value={endOption.value}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-right mt-4 col-10">
                    <div className="px-2 col-4">
                        <label className="fw-medium">Date</label>
                        <div className="mt-2">
                            <InputFiled
                                tabIndex={4}
                                type="date"
                                register={register}
                                name="date"
                                errors={errors}
                                className="form-control"
                                placeholder="MM/DD/YYYY"
                            />
                        </div>
                    </div>
                    <div className="px-2 col-4">
                        <label className="fw-medium">Occurrences</label>
                        <div className="mt-2">
                            <InputFiled
                                tabIndex={4}
                                type="text"
                                register={register}
                                name="occurrences"
                                errors={errors}
                                className="form-control"
                                placeholder="Enter Sugg. Stock Level"
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                    <FormButton
                        tabIndex={25}
                        className="sph-btn me-2"
                        handleClick={() => {
                            navigate("/inventory/counts/cycle-count/by-location");
                        }}>
                        Cancel
                    </FormButton>
                    <FormButton
                        tabIndex={26}
                        className="sph-btn sph-shift"
                        handleClick={() => {
                            navigate("/inventory/counts/cycle-count/by-location");
                        }}>
                        Done
                    </FormButton>
                </div>
            </form>
        </div>
    );
};

export default ScheduleCountByLocationModal;